import { Box, Grid, Typography, useMediaQuery, useTheme } from '@mui/material'
import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import Buttons from '../Components/Buttons'
import { ROUTER } from '../router/constants'
import { allOptions, labels } from '../constant/SelectsData'
import SelectInput from '../Components/SelectInput'

const Setting = ({backLink, checkLink}) => {


    const [values, setValues] = useState(['16°', '50°', 'شکوفه گیلاس', 'کم']);

    const theme = useTheme()
    const isLargeScreen = useMediaQuery(theme.breakpoints.up('lg'))

    const navigate = useNavigate()


    const handleConfirmSetting = () => {
        checkLink ? navigate(checkLink) : navigate(ROUTER.SYSTEMS)
    }

    const handleChange = (index) => (event) => {
        const newValues = [...values];
        newValues[index] = event.target.value;
        setValues(newValues);
    };

    return (
        <div className='container' style={{ padding: isLargeScreen ? '60px 40px' : '30px 20px', backgroundColor: 'white', borderRadius: '10px', boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -4px rgba(0, 0, 0, 0.1)' }}>
            <Typography variant={isLargeScreen ? 'h1' : 'h2'} align="center" color='black' sx={{ fontWeight: isLargeScreen ? 600 : 700, color: 'black', mb: '64px' }}>
                تنظيمات
            </Typography>
            <Box sx={{ mb: "64px" }}>
                <div className='two-column-grid'>
                    {allOptions.map((options, idx) => (
                        <SelectInput
                            key={idx}
                            options={options}
                            value={values[idx]}
                            onChange={handleChange(idx)}
                            label={labels[idx]}
                        />
                    ))}
                </div>
            </Box>
            <Buttons backTitle={'بازگشت'} checkTitle={'ثبت'} backLink={backLink ? backLink : ROUTER.RESERVE_CONFIRM} checkLink={''} onCheck={handleConfirmSetting} />
        </div>
    )
}

export default Setting
